// import Services from '@/services/index';
// import VT from '@/store/types';

export default {
  // [VT.SAMPLE_LABEL_SET_DELETE]: ({}, id) => {
  //   return new Promise((resolve, reject) => {
  //     Services.sampleLabelSets.delete(id).then((data) => {
  //       resolve(data);
  //     }).catch((data) => {
  //       reject(data);
  //     });
  //   });
  // },
};
